module.exports = __webpack_public_path__ + "static/media/30.7d5348cc.jpg";